/*
 * @Author: Ryan
 * @Date: 2026-01-08
 * @Description: Landing 页面 Hero Section 组件
 */
import dynamic from 'next/dynamic';
import React from 'react';

import styles from './index.module.scss';
import LanguageSelector from './LanguageSelector';
import UploadArea from './UploadArea';

// 动态加载视频组件，客户端渲染
const VideoShowcase = dynamic(() => import('./VideoShowcase'), {
  ssr: false,
});

export interface HeroSectionProps {
  title: string;
  subtitle: string;
  ctaText: string;
  sourceLanguageLabel: string;
  sourceLanguageDefault: string;
  targetLanguageLabel: string;
  targetLanguageDefault: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  ctaText,
  sourceLanguageLabel,
  sourceLanguageDefault,
  targetLanguageLabel,
  targetLanguageDefault,
}) => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.container}>
        {/* 左侧内容区 */}
        <div className={styles.content}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.subtitle}>{subtitle}</p>

          {/* 语言选择器 */}
          <LanguageSelector
            sourceLanguageLabel={sourceLanguageLabel}
            sourceLanguageDefault={sourceLanguageDefault}
            targetLanguageLabel={targetLanguageLabel}
            targetLanguageDefault={targetLanguageDefault}
          />

          {/* 上传区域 */}
          <UploadArea ctaText={ctaText} />
        </div>

        {/* 右侧视频展示 */}
        <div className={styles.videoWrapper}>
          <VideoShowcase />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
